import React, { useState } from "react";
import Agent from "./Agent";
import data from "../../../../data/data";

import "./agents.scss";

function Agents(props) {
  const [AgentList, setAgentList] = useState(data);

  const [current, SetCurrent] = useState(3);

  const nextProperty = () => {
    SetCurrent(current + 1);
  };

  const prevProperty = () => {
    SetCurrent(current - 1);
  };

  const setnow = (i) => {
    SetCurrent(i);
  };

  return (
    <section className='agents flex flex-col items-center overflow-x-hidden pt-10'>
      <h1 className=' text-3xl  text-white tracking-widest font-extrabold uppercase  '>
        Agents
      </h1>

      <div className={`mt-10 cards-slider active-slide-${current}`}>
        <div
          onClick={prevProperty}
          className={current === 0 ? "ArrowsLeft hidden" : "ArrowsLeft"}
        >
          <div class='custom-cplace-arrows bottom'></div>
          <div class='custom-cplace-arrows up'></div>
        </div>
        <div
          onClick={nextProperty}
          className={
            current === AgentList.length - 1
              ? "ArrowsRight hidden"
              : "ArrowsRight"
          }
        >
          <div class='custom-cplace-arrows bottom'></div>
          <div class='custom-cplace-arrows up'></div>
        </div>
        <div
          className='cards-slider-wrapper'
          style={{
            transform: `translateX(-${current * (100 / AgentList.length)}%)`,
          }}
        >
          {AgentList.map((agent, index) => (
            <Agent
              index={index}
              key={agent.name}
              setnow={setnow}
              agent={agent}
              history={props.history}
              active={current === index ? true : false}
            ></Agent>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Agents;
